module.exports = __webpack_public_path__ + "static/media/planeta4.78532529.png";